const TipStyle = {
    tipsBoxShow: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        position: 'relative',
    },
    tipsBoxHide: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
        overflow: "hidden",
        height: 0,
        width: 0
    },
    svgBox: {
        marginTop: '2.5rem',
    },
    body: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        margin: '0 2.5rem',
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0.5rem 0',
        fontSize: '1.5rem',
        color: "#6d7580"
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        fontSize: '0.875rem',
        color: "#999999",
        marginTop:"0.5rem",
        marginBottom: '0.5rem',
        wordBreak: "break-all",
    },
    buttonBoxOn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginBottom: '2.1875rem',
        fontSize: '1.125rem',
        transition: 'all 0.5s',
        cursor: "pointer",
        marginTop:"0.5rem"
    },
    buttonBoxOff: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        marginBottom: '-1rem',
        transition: 'all 0.5s',
        cursor: "pointer",
        marginTop:"0.5rem"
    },


    hint: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '15.625rem',
        height: '2.5rem',
        background: "#ffbe62",
        color: '#fff',
        borderRadius: '0.25rem',
    },
    hintLeft: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '11.875rem',
        height: '2.5rem',
        background: "#ffbe62",
        color: '#fff',
        borderRadius: '0.25rem',
        margin: '0 1rem',

    },
    hintRight: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '11.875rem',
        height: '2.5rem',
        color: '#000',
        border: 'solid 0.08rem #dfdfdf',
        borderRadius: '0.25rem',
        margin: '0 1rem',
    },


};
export  default TipStyle
